import { SurfaceType } from 'api/resort/types';
import { useSurfaceTypeTranslation } from 'i18n/useOTSTranslation';

export const SnowType = ({ type }:{ type?: SurfaceType }) => {
  const eT = useSurfaceTypeTranslation();
  return <>{type ? eT(type) : ''}</>;
};
